module.exports = __webpack_public_path__ + "static/media/two-person-icon.9872f02b.svg";